import { cssVar } from '@mfw/common';
import type { CheckboxProps } from '@mui/material/Checkbox';
import type { Theme } from '@mui/material/styles';

import { checkboxClasses } from '@mui/material/Checkbox';

import type { OnSurfaceMarkFamily } from '../../onSurface';

import { ON_SURFACE_MARK_FAMILIES, onSurfaceMark } from '../../onSurface';

// ----------------------------------------------------------------------

export function checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: CheckboxProps }) => {
          const { color } = ownerState;

          return {
            padding: theme.spacing(1),
            ...(color === 'default' && {
              [`&.${checkboxClasses.checked}`]: {
                color: cssVar.text.primary,
              },
            }),
            // The checked box is a filled square with the tick knocked out of
            // it: the colour IS the state, drawn on the page, so it is a MARK.
            // MUI paints it `<color>.main`, which a light tenant reads at
            // 1.7:1; the mark step is the one measured at 3:1 against the page
            // and the cards. The hover wash MUI derives from `main` is a fill
            // and stays. Before the disabled block, which must win.
            ...(ON_SURFACE_MARK_FAMILIES.includes(
              color as OnSurfaceMarkFamily,
            ) && {
              [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]:
                { color: onSurfaceMark[color as OnSurfaceMarkFamily] },
            }),
            [`&.${checkboxClasses.disabled}`]: {
              color: theme.palette.action.disabled,
            },
          };
        },
      },
    },
  };
}
